import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        // Botão principal com gradiente azul para roxo
        default:
          "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300",
        // Botão destrutivo com gradiente vermelho para rosa
        destructive:
          "bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus-visible:ring-red-500/20 dark:focus-visible:ring-red-500/40",
        // Botão outline com gradiente sutil e borda
        outline:
          "bg-gradient-to-r from-gray-100 to-gray-200 hover:from-blue-50 hover:to-purple-50 border border-gray-300 hover:border-blue-400 text-gray-700 hover:text-blue-700 shadow-sm hover:shadow-md transform hover:scale-105 transition-all duration-300 dark:from-gray-800 dark:to-gray-700 dark:hover:from-blue-900/50 dark:hover:to-purple-900/50 dark:border-gray-600 dark:hover:border-blue-500 dark:text-gray-300 dark:hover:text-blue-300",
        // Botão secundário com gradiente verde para azul
        secondary:
          "bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300",
        // Botão ghost com gradiente sutil no hover
        ghost:
          "hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 hover:text-blue-700 transform hover:scale-105 transition-all duration-300 dark:hover:from-blue-900/30 dark:hover:to-purple-900/30 dark:hover:text-blue-300",
        // Link mantém estilo original mas com cor gradiente
        link: "bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hover:from-blue-700 hover:to-purple-700 underline-offset-4 hover:underline transition-all duration-300",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props} />
  );
}

export { Button, buttonVariants }
